var map = {
	"./Online_life_is_real_life_Parents.docx": 1096,
	"./Online_life_is_real_life_Parents.pdf": 1097,
	"./Online_life_is_real_life_Parents_EN.pdf": 1098,
	"./Primary_Tips.docx": 1099,
	"./Primary_Tips.pdf": 1100,
	"./Primary_Tips_EN.pdf": 1101,
	"./img_featuredissues-sexting_CH_V2.png": 1102,
	"./img_featuredissues-sexting_V2.png": 1103,
	"./img_featuredissues-sextingonline_grooming.png": 1104,
	"./img_featuredissues-sextingonline_grooming_CH.png": 1105,
	"./img_resourceforyou-General_Tips.png": 1106,
	"./img_resourceforyou-General_Tips_CH.png": 1107,
	"./online_safety_checklist-CH_combine.jpg": 1108,
	"./online_safety_checklist-CH_combine.pdf": 1109,
	"./online_safety_checklist-CH_combine2.pdf": 1110,
	"./online_safety_checklist-EN_combine.jpg": 1111,
	"./online_safety_checklist-EN_combine.pdf": 1112,
	"./online_safety_checklist-EN_combine2.pdf": 1113,
	"./socialMediaGuide/Facebook_Guide_Chin_Android.docx": 1114,
	"./socialMediaGuide/Facebook_Guide_Chin_Android.pdf": 1115,
	"./socialMediaGuide/Facebook_Guide_Chin_Computer.docx": 1116,
	"./socialMediaGuide/Facebook_Guide_Chin_iOS.docx": 1117,
	"./socialMediaGuide/Facebook_Guide_Chin_iOS.pdf": 1118,
	"./socialMediaGuide/Messenger_Guide_Chin.docx": 1119,
	"./socialMediaGuide/Messenger_Guide_Chin.pdf": 1120,
	"./socialMediaGuide/Snapchat_Guide_Chin.docx": 1121,
	"./socialMediaGuide/Snapchat_Guide_Chin.pdf": 1122,
	"./socialMediaGuide/TikTok_Chin_Android.docx": 1123,
	"./socialMediaGuide/TikTok_Chin_Android.pdf": 1124,
	"./socialMediaGuide/TikTok_Chin_iOS.docx": 1125,
	"./socialMediaGuide/TikTok_Chin_iOS.pdf": 1126,
	"./socialMediaGuide/WeChat_Guide_Chin_Android.docx": 1127,
	"./socialMediaGuide/WeChat_Guide_Chin_Android.pdf": 1128,
	"./socialMediaGuide/WeChat_Guide_Chin_Apple.docx": 1129,
	"./socialMediaGuide/WeChat_Guide_Chin_Apple.pdf": 1130,
	"./socialMediaGuide/Whatsapp_Guide_Android_Chin.docx": 1131,
	"./socialMediaGuide/Whatsapp_Guide_Android_Chin.pdf": 1132,
	"./socialMediaGuide/Whatsapp_Guide_iOS_Chin.docx": 1133,
	"./socialMediaGuide/Whatsapp_Guide_iOS_Chin.pdf": 1134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;